import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { CalendarIcon, ClipboardListIcon, RepeatIcon, SettingsIcon, LogOutIcon, MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const {
    user,
    logout
  } = useUser();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (!user) return null;
  const handleLogout = () => {
    logout();
    navigate('/login');
    setIsMobileMenuOpen(false);
  };
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  return <nav className="text-white shadow-md" style={{
    backgroundColor: '#4772B0'
  }} data-id="element-358">
      <div className="container mx-auto px-4" data-id="element-359">
        <div className="flex justify-between items-center py-4" data-id="element-360">
          <Link to="/" className="flex items-center space-x-3" onClick={closeMobileMenu} data-id="element-361">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pqFwhPa2herr53Qjo4Lf86/image.png" alt="RowDate.com" className="h-10 w-auto" data-id="element-362" />
          </Link>
          <div className="hidden md:flex space-x-6" data-id="element-363">
            <Link to="/" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-364">
              <CalendarIcon className="mr-1" size={18} data-id="element-365" /> Dashboard
            </Link>
            <Link to="/calendar" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-366">
              <CalendarIcon className="mr-1" size={18} data-id="element-367" /> Calendar
            </Link>
            <Link to="/request-shifts" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-368">
              <ClipboardListIcon className="mr-1" size={18} data-id="element-369" /> Request Shifts
            </Link>
            <Link to="/trade-shifts" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-370">
              <RepeatIcon className="mr-1" size={18} data-id="element-371" /> Trade Shifts
            </Link>
            {user.isAdmin && <Link to="/admin" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-372">
                <SettingsIcon className="mr-1" size={18} data-id="element-373" /> Admin Settings
              </Link>}
          </div>
          <div className="flex items-center space-x-4" data-id="element-374">
            <span className="hidden md:inline" data-id="element-375">{user.name}</span>
            <button onClick={handleLogout} className="hidden md:flex items-center hover:text-gray-200 transition-colors" data-id="element-376">
              <LogOutIcon size={18} className="mr-1" data-id="element-377" /> Logout
            </button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 hover:bg-blue-700 rounded transition-colors" data-id="element-378">
              {isMobileMenuOpen ? <XIcon size={24} data-id="element-379" /> : <MenuIcon size={24} data-id="element-380" />}
            </button>
          </div>
        </div>
        {isMobileMenuOpen && <div className="md:hidden pb-4 space-y-2" data-id="element-381">
            <Link to="/" className="flex items-center py-2 px-4 hover:bg-blue-700 rounded transition-colors" onClick={closeMobileMenu} data-id="element-382">
              <CalendarIcon className="mr-2" size={18} data-id="element-383" /> Dashboard
            </Link>
            <Link to="/calendar" className="flex items-center py-2 px-4 hover:bg-blue-700 rounded transition-colors" onClick={closeMobileMenu} data-id="element-384">
              <CalendarIcon className="mr-2" size={18} data-id="element-385" /> Calendar
            </Link>
            <Link to="/request-shifts" className="flex items-center py-2 px-4 hover:bg-blue-700 rounded transition-colors" onClick={closeMobileMenu} data-id="element-386">
              <ClipboardListIcon className="mr-2" size={18} data-id="element-387" /> Request Shifts
            </Link>
            <Link to="/trade-shifts" className="flex items-center py-2 px-4 hover:bg-blue-700 rounded transition-colors" onClick={closeMobileMenu} data-id="element-388">
              <RepeatIcon className="mr-2" size={18} data-id="element-389" /> Trade Shifts
            </Link>
            {user.isAdmin && <Link to="/admin" className="flex items-center py-2 px-4 hover:bg-blue-700 rounded transition-colors" onClick={closeMobileMenu} data-id="element-390">
                <SettingsIcon className="mr-2" size={18} data-id="element-391" /> Admin Settings
              </Link>}
            <div className="border-t border-blue-600 pt-2 mt-2" data-id="element-392">
              <div className="px-4 py-2 text-sm" data-id="element-393">{user.name}</div>
              <button onClick={handleLogout} className="flex items-center w-full py-2 px-4 hover:bg-blue-700 rounded transition-colors" data-id="element-394">
                <LogOutIcon size={18} className="mr-2" data-id="element-395" /> Logout
              </button>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navbar;